<template>
  <div class="board-card-wrapper">
    <div class="board-card-header">
      <div class="info-card" :class="andon ? 'andon' : ''">
        <div class="card-id">{{cardId}}</div>
        <div class="card-contact">{{cardContact}}</div>
      </div>
      <div class="andon-lead-info" :class="andon ? 'andon' : ''">
        <p style="font-size: 1.2rem;">{{computedLeadTime}}</p>
      </div>
    </div>
    <div class="board-card-content" :class="andon ? 'andon' : ''">
      <div class="description-card">{{cardDescription}}</div>
      <div v-if="internalSupplier" class="internal-supplier-info">Carte attribuée à : <b>{{internalSupplier}}</b></div>
      <br>
      <div class="asking-date-format" :class="andon ? 'andon' : ''">{{askingDate}}</div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'BoardCard',
  props: ['cardId', 'computedLeadTime', 'cardContact', 'askingDate', 'cardDescription', 'andon', 'internalSupplier'],
}
</script>

<style type="css" scoped>
.board-card-wrapper {
  min-width: 12rem;
  border-radius: 3px;
  overflow: hidden;
  margin: 1rem;
  box-shadow: 3px 5px 10px 4px rgb(63 63 63 / 25%);
}

.board-card-header {
  min-height: 5rem;
  height: auto;
  display: flex;
  justify-content: space-between;
  border-radius: 3px;
  background-color: #fff;
}

.board-card-content.andon {
  min-height: 5rem;
  height: auto;
  background-color: #f1a6a4;
  color: #87221c;
  position: relative;
}

.board-card-content {
  min-height: 5rem;
  height: auto;
  background-color: white;
  color: black;
  position: relative;
}

.andon-lead-info.andon {
  background-color: #efd8d8;
  color: #e83f35;
  flex-basis: 15%;
  padding: 1.2rem;
  border-radius: 0 3px 0 0;
}

.andon-lead-info {
  background-color: #ececec;
  color: black;
  flex-basis: 15%;
  padding: 1.2rem;
  border-radius: 0 3px 0 0;
}

.info-card.andon {
  flex-grow: 1;
  padding: 0.3rem 0.5rem;
  background-color: #ee827f;
  color: #fff;
  border-radius: 3px 0 0 0;
  text-align: left;
}

.info-card {
  flex-grow: 1;
  padding: 0.3rem 0.5rem;
  background-color: #bebebe;
  color: #353636;
  border-radius: 3px 0 0 0;
  text-align: left;
}

.info-card .card-id {
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 0.5rem;
}

.info-card .card-contact {
  font-size: 15px;
  font-weight: bold;
}

.asking-date-format {
  font-weight:normal; 
  text-align: right;
  font-size: 15px;
  padding: 0.2em;
  position: absolute;
  bottom: 0;
  right: 0;
}

.asking-date-format.andon {
  font-weight: bold;
}

.description-card {
  font-weight: bold;
  padding: .5rem .5rem;
  font-size: 16px;
}

.internal-supplier-info {
  font-weight:normal; 
  text-align: right;
  font-size:12px;
  padding: 0.5em;
  position: absolute;
  bottom: 0;
  left: 0;
}

</style>



// WEBPACK FOOTER //
// BoardCard.vue?186d194f